import { render, staticRenderFns } from "./details.component.vue?vue&type=template&id=24ac9f6d"
import script from "./details.component.vue?vue&type=script&lang=js"
export * from "./details.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports